import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/mtska-frontend-app-component';

const TemporaryRemoval = ({ selectedElements }) => {
	const { t } = useTranslation();
	const [selected, setSelected] = useState();
	useEffect(() => setSelected(selectedElements), [selectedElements]);

	const handleTemporaryRemoval = () => {
		console.info('isSelected', selected)
		//setValues(selected);
		//apiRef.current.updateRows(selectedRows.map(id => ({ id, _action: 'remove' })));
		console.info('tempRemoval', selected)
	};

	return [
		<Button
			onClick={handleTemporaryRemoval}
			label={t("Escludi")}
			icon="faTrash"
			variant="outlined"
			size="small"
			className="button-delete"
		/>
	];
};

export default TemporaryRemoval;
